__turbopack_context__.v({
  "btnContent": "index-module__dSZorW__btnContent",
  "customInput": "index-module__dSZorW__customInput",
  "otherBtnsWrapper": "index-module__dSZorW__otherBtnsWrapper",
  "wrapper": "index-module__dSZorW__wrapper",
});
